module.exports = __webpack_public_path__ + "img/promotion_banner.jpg?v=79ba9652";